import script from "./taxes-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./taxes-modal.vue?vue&type=script&setup=true&lang=js"

import "./taxes-modal.vue?vue&type=style&index=0&id=0b302f5b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b302f5b"]])

export default __exports__